import styled from 'styled-components';

export const CommentSectionContainer = styled.div`
  padding: 24px;
  background-color: ${(props) =>
    props.isEditing
      ? 'white' // Active comment when editing
      : props.isResolved
      ? '#f9f9f9' // Grey for resolved comments
      : 'white'};
  border-left: ${(props) =>
    props.isEditing
      ? '4px solid blue' // Highlight for active editing
      : props.isResolved
      ? '4px solid green' // Green for resolved
      : '4px solid transparent'};
  opacity: ${(props) => (props.isEditing || !props.isResolved ? 1 : 0.7)}; // Full opacity for editing or unresolved
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
`;

export const CommentAligmentItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
`;

export const CommentAligmentButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

export const ReadMoreButtonStyle = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  text-align: center;
`;
